import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import styles from './styles';

const SelectDrillDetails = (props) => {
  const { id, value, field, data, updateData, label, decimals } = props;
  const apiRef = useGridApiContext();
  const classes = styles();

  const handleChange = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    updateData(
      id,
      field,
      event.target.value
    );
    if (props?.closeCellAfterSelect) {
      await apiRef.current.setEditCellValue({ id, field, value: event.target.value });
      apiRef.current.setCellMode(id, field, 'view');
    }
  };

  return (
    <FormControl
      variant="filled"
      className={classes.inputField}
      sx={{ bgcolor: 'transparent' }}
    >
      <InputLabel id={`signal-label-${id}`}>Select One</InputLabel>
      <Select
        labelId={`signal-select-${id}`}
        id={`signal-select-${id}`}
        value={value}
        onChange={handleChange}
        label={value}
        disableUnderline
      >
        {data?.map((item, idItem) => (
          <MenuItem key={`item_${item?.name}_${idItem}`} value={`${item?.name?.trim()} @ ${item?.MD.toFixed(decimals)}${label}`} sx={{ fontSize: '18px' }} style={{ fontWeight: 'bold' }}>
          {`${item?.name?.trim()} @ ${item?.MD.toFixed(decimals)}${label}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

SelectDrillDetails.propTypes = {
  field: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.any,
  data: PropTypes.any,
  updateData: PropTypes.func,
  closeCellAfterSelect: PropTypes.any,
  label: PropTypes.any,
  decimals: PropTypes.any
};

export default SelectDrillDetails;
